// Global open-state for `<MainnetConstructionModal />`.
//
// The modal mounts once at the app-shell level and any callsite that
// detects an attempt to switch into mainnet while `mainnet_enabled` is
// off (the wallet-dropdown toggle, the demo-not-found card, etc.) flips
// `open` to true. Centralised so multiple triggers share one mounted
// modal — no duplicate <Dialog> instances.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface MainnetConstructionModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useMainnetConstructionModalStore: UseBoundStore<
  StoreApi<MainnetConstructionModalState>
> = createTrackedStore<MainnetConstructionModalState>('useMainnetConstructionModalStore')(
  (set) => ({
    open: false,
    setOpen: (open: boolean): void => set({ open }),
  }),
);
